import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface FrameProps {
	isActive: boolean;
	canDragAndResize: boolean;
	isVideoCover: boolean;
	width: number;
	height: number;
}

interface FrameBorderProps {
	isActive: boolean;
	borderWidth: number;
	borderColor?: string;
}

interface FrameLoaderProps {
	borderWidth: number;
}

interface FrameLoaderInnerProps {
	scale: number;
}

const Frame = styled('div')`
	position: relative;
	width: ${(props: FrameProps) => `${props.width}px`};
	height: ${(props: FrameProps) => `${props.height}px`};
	overflow: ${(props: FrameProps) => props.isActive ? 'visible' : 'hidden'};
	pointer-events: ${(props: FrameProps) => props.isActive && props.canDragAndResize ? 'none' : 'auto'};
	border-radius: inherit;

	[class*="is-rounded"] & {
		border-radius: 50%;
	}

	img, svg {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		max-width: 100%;
		max-height: 100%;
		width: ${(props: FrameProps) => props.isVideoCover ? 'auto' : '100%'};
		height: auto;
		margin: auto;
		pointer-events: auto;
	}

	svg {
		width: 50%;
		height: 50%;
		fill: ${NewStyleColor.Grey400};
	}
`;

const FrameBorder = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	border: ${(props: FrameBorderProps) => `${props.borderWidth}px`}
		solid
		${(props: FrameBorderProps) => props.isActive ? `${NewStyleColor.Blue100}` : `${props.borderColor || NewStyleColor.Grey400}`};
	border-radius: inherit;
`;

const FrameLoader = styled('div')`
	position: absolute;
	top: ${(props: FrameLoaderProps) => `${props.borderWidth}px`};
	bottom: ${(props: FrameLoaderProps) => `${props.borderWidth}px`};
	left: ${(props: FrameLoaderProps) => `${props.borderWidth}px`};
	right: ${(props: FrameLoaderProps) => `${props.borderWidth}px`};
	z-index: 1;
`;

const FrameLoaderInner = styled('div')`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: ${(props: FrameLoaderInnerProps) => `translate(-50%, -50%) scale(${1 / props.scale})`};
	padding: 5px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Grey800};
	text-align: center;

	span {
		display: block;
	}
`;

const FrameMask = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${NewStyleColor.White};
	opacity: 0.9;
`;

export {
	Frame,
	FrameBorder,
	FrameLoader,
	FrameLoaderInner,
	FrameMask,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/MediaEditor/styles.ts